import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import ReduxState from 'models/redux';
import { useDispatch } from 'react-redux';

export interface ReduxAction<A> extends Action<string> {
    value: A
}

export interface ThunkPromiseAction<R,A = any> extends ThunkAction<Promise<R>, ReduxState, any, ReduxAction<A>> {}
export type ThunkDispatchFunction = (<T = any>(action: ThunkPromiseAction<T> | ReduxAction<T>) => Promise<T> | T) 
export interface ThunkDispatchProp {
    dispatch: ThunkDispatchFunction
}

export interface ReduxDispatch<S> extends ThunkDispatch<ReduxState, any, ReduxAction<S>> {}

export const dispatchMap = (dispatch: ThunkDispatch<ReduxState, any, ReduxAction<any>>) => ({
    dispatch: <T = any>(arg: ThunkPromiseAction<T> | ReduxAction<T>) => dispatch(arg as any) as Promise<T> | T
});

export const useThunkDispatch = () => useDispatch() as ThunkDispatchFunction

export type StateGetter = () => ReduxState

  
